import { FormEvent, FunctionComponent, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Form } from '../../components/Form';
import { DatePicker } from '../../components/Input';
import { UploadFile } from './UploadFile';
import { Button } from '../../components/Button';
import { SideBar } from '../../components/SideBar';
import { Title } from '../../components/Typography';
import { ProductsList } from './ProductsList';
import { BarCodeScanner } from './BarCodeScanner';

import { formDataApi } from '../../utils/api';
import { getUser } from '../../selectors/user';
import { showMessage } from '../../actions/message';

import classes from './add-warranty.module.scss';

export const RegisterWarranty: FunctionComponent = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(false);
  const [receipt, setReceipt] = useState<File | undefined>();
  const [purchaseDate, setPurchaseDate] = useState('');
  const [productCode, setProductCode] = useState('');

  const onFileDrop = useCallback((acceptedFiles: File[]) => {
    setReceipt(acceptedFiles[0]);
  }, []);

  const onSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();

      if (productCode.length > 0 && purchaseDate && receipt) {
        setFetching(true);

        const body = new FormData();

        body.append('codice_prodotto', productCode);
        body.append('data_acquisto', purchaseDate);
        body.append('scontrino_src', receipt);

        try {
          const { status } = await formDataApi.post(
            `/user/${user.data!.id}/warranties`,
            {
              Authorization: `Bearer ${user.data!.token}`,
            },
            body
          );

          if (status === 'OK') {
            dispatch(
              showMessage({ message: 'Prodotto registrato con successo' })
            );
            navigate('/');
          }
        } catch {
          dispatch(
            showMessage({
              message:
                'Si è verificato un errore durante la registrazione del prodotto',
              type: 'danger',
            })
          );
        } finally {
          setFetching(false);
        }
      } else {
        dispatch(
          showMessage({
            message: 'Per favore compila tutti i campi richiesti',
            type: 'danger',
          })
        );
      }
    },
    [dispatch, productCode, purchaseDate, receipt, user.data, navigate]
  );

  return (
    <div className={classes.warranty}>
      <SideBar>
        <Title as={'h3'}>Registra prodotto</Title>

        <Form onSubmit={onSubmit}>
          <BarCodeScanner
            onDetected={setProductCode}
            onTextChange={setProductCode}
            value={productCode}
          />

          <ProductsList code={productCode} onSelect={setProductCode} />

          <DatePicker
            label={'Data di acquisto'}
            onChange={setPurchaseDate}
            value={purchaseDate}
            required
          />

          <UploadFile file={receipt} onDrop={onFileDrop} />

          <Button loading={fetching} type={'submit'}>
            Registra
          </Button>
        </Form>
      </SideBar>
    </div>
  );
};
